<template>
    <div class="min-h-screen flex flex-col items-center pt-6 sm:pt-0 bg-stapp-bg">
        <div class="w-full sm:max-w-md mt-6 px-6 overflow-hidden sm:rounded-lg">
            <slot name="logo" />
        </div>

        <div class="w-full sm:max-w-md mt-6 px-6 py-4 overflow-hidden sm:rounded-lg">
            <slot />
        </div>
    </div>
</template>
